/**
 * @public
 */ export var AdBreakType = /*#__PURE__*/ function(AdBreakType) {
    AdBreakType["Preroll"] = "Preroll";
    AdBreakType["Midroll"] = "Midroll";
    AdBreakType["Postroll"] = "Postroll";
    return AdBreakType;
}({});
/**
 * @public
 */ export var SsaiStitcherType = /*#__PURE__*/ function(SsaiStitcherType) {
    SsaiStitcherType["Yospace"] = "Yospace";
    SsaiStitcherType["MediaTailor"] = "MediaTailor";
    SsaiStitcherType["None"] = "NA";
    return SsaiStitcherType;
}({});
/* None applies to CSAI */ /**
 * @public
 */ export var AdMetadataSource = /*#__PURE__*/ function(AdMetadataSource) {
    AdMetadataSource["Manifest"] = "Manifest";
    AdMetadataSource["MediaTailor"] = "MediaTailor";
    return AdMetadataSource;
}({});
/**
 * @public
 */ /**
 * @public
 */ /**
 * @public
 */ // Required
// Optional
/**
 * @public
 */ /**
 * @public
 */ export var AdExtensionType = /*#__PURE__*/ function(AdExtensionType) {
    AdExtensionType["FreeWheel"] = "FreeWheel";
    return AdExtensionType;
}({});
/**
 * @public
 */ export var CompanionProvider = /*#__PURE__*/ function(CompanionProvider) {
    CompanionProvider["Brightline"] = "Brightline";
    return CompanionProvider;
}({});
// Defined by the VAST spec
// Required property in the vast spec but missing from ATV data
// Required property in the vast spec but missing from ATV data
export var TrackingEventType = /*#__PURE__*/ function(TrackingEventType) {
    TrackingEventType["BreakStart"] = "breakStart";
    TrackingEventType["BreakEnd"] = "breakEnd";
    TrackingEventType["AdImpression"] = "impression";
    TrackingEventType["AdStart"] = "start";
    TrackingEventType["AdFinished"] = "complete";
    TrackingEventType["ContentResuming"] = "complete";
    TrackingEventType["Skipped"] = "skip";
    TrackingEventType["FirstQuartile"] = "firstQuartile";
    TrackingEventType["Midpoint"] = "midpoint";
    TrackingEventType["ThirdQuartile"] = "thirdQuartile";
    TrackingEventType["Error"] = "error";
    TrackingEventType["Mute"] = "mute";
    TrackingEventType["Unmute"] = "unmute";
    TrackingEventType["Collapse"] = "collapse";
    TrackingEventType["Expand"] = "expand";
    TrackingEventType["Pause"] = "pause";
    TrackingEventType["Resume"] = "resume";
    TrackingEventType["Rewind"] = "rewind";
    TrackingEventType["AcceptInvitation"] = "acceptInvitation";
    TrackingEventType["Close"] = "close";
    TrackingEventType["CreativeView"] = "creativeView";
    return TrackingEventType;
}({});
/**
 * Used to define multiview player types. ( Reference: https://gspcloud.atlassian.net/browse/VPTJS-9492 )
 * Be aware the keys and values of this enum are used to define the player display types.
 * For example when in multiview mode the enum key will be used to create a property of `multiplayer` and the value of `multiview`
 * will be assigned to it. If you have a need to change the key or value please ensure that it will not cause any unintended issues.
 * The key and value are paired together on purpose as they result in vamParams and those should not be changed without adequate reason and verification.
 */ export var MultiPlayerDisplayType = /*#__PURE__*/ function(MultiPlayerDisplayType) {
    MultiPlayerDisplayType["MultiView"] = "multiview";
    return MultiPlayerDisplayType;
}({});
export var AdStreamType = /*#__PURE__*/ function(AdStreamType) {
    AdStreamType["InStream"] = "InStream";
    AdStreamType["Separate"] = "Separate";
    return AdStreamType;
}({});
export var AdStatus = /*#__PURE__*/ function(AdStatus) {
    AdStatus["Unwatched"] = "Unwatched";
    AdStatus["Watched"] = "Watched";
    AdStatus["Skipped"] = "Skipped";
    AdStatus["Errored"] = "Errored";
    return AdStatus;
}({});
export var AdBreakEventStatus = /*#__PURE__*/ function(AdBreakEventStatus) {
    AdBreakEventStatus["NEW_BREAK"] = "NEW_BREAK";
    AdBreakEventStatus["ACTIVE_BREAK"] = "ACTIVE_BREAK";
    AdBreakEventStatus["UPDATED_BREAK"] = "UPDATED_BREAK";
    return AdBreakEventStatus;
}({});
export var SupportedMediaFileTypes = /*#__PURE__*/ function(SupportedMediaFileTypes) {
    SupportedMediaFileTypes["VideoMp4"] = "video/mp4";
    SupportedMediaFileTypes["ApplicationDash"] = "application/dash+xml";
    return SupportedMediaFileTypes;
}({});
export var MetadataType = /*#__PURE__*/ function(MetadataType) {
    MetadataType["PodBegin"] = "PodBegin";
    MetadataType["PrerollPodBegin"] = "PrerollPodBegin";
    MetadataType["PodEnd"] = "PodEnd";
    MetadataType["PrerollPodEnd"] = "PrerollPodEnd";
    MetadataType["AdBegin"] = "AdBegin";
    MetadataType["AdEnd"] = "AdEnd";
    // Not 100% sure this event exists, but it would make sense if it did.
    MetadataType["NonLinearPod"] = "NonLinearPod";
    return MetadataType;
}({});
export var AdBreakSource = /*#__PURE__*/ function(AdBreakSource) {
    AdBreakSource["Paginated"] = "Paginated";
    AdBreakSource["Unpaginated"] = "Unpaginated";
    AdBreakSource["Manifest"] = "Manifest";
    AdBreakSource["OutOfBand"] = "OutOfBand";
    return AdBreakSource;
}({});
// From VAM or another source
export var AdBreakUpdateMergeStrategy = /*#__PURE__*/ function(AdBreakUpdateMergeStrategy) {
    AdBreakUpdateMergeStrategy["Overwrite"] = "overwrite";
    AdBreakUpdateMergeStrategy["Merge"] = "merge";
    return AdBreakUpdateMergeStrategy;
}({});

//# sourceMappingURL=types.js.map